import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterConfig } from '../../models/filter-config';
import { FilterType } from '../../models/filter-type.enum';
import { FilterOption } from '../../models/filter-option.model';

@Component({
  selector: 'app-filter-overlay',
  templateUrl: './filter-overlay.component.html',
  styleUrl: './filter-overlay.component.css'
})
export class FilterOverlayComponent {
  @Input() config!: FilterConfig;

  @Output() selected = new EventEmitter();
  
  consolidado: FilterOption;
  tipos = FilterType;
  private filter = '';
  arregloMostrar: FilterOption[] = [];

  constructor(){} 
  
  ngOnChanges(){
    this.config = this.config;
    this.arregloMostrar = [...this.config.options];

    if(this.filter !== ''){
      this.filtrado(this.filter);
    }
    this.consolidado = {
      id: this.config.textoConsolidado,
      label: this.config.textoConsolidado,
      value: 'consolidado',
      selected: this.config.consolidado
    }
  }

  selection(item){
    if(item.children) return;
    this.selected.emit(item);
  }

  filtrado(filtrar){
    this.filter = filtrar;
    this.arregloMostrar = this.config.options.filter(e =>
      `${e.id}`.toLowerCase().includes(this.filter.toLowerCase())
    );
  }
}
